import React from "react";
import { ModalOverlay, ModalCard, ModalTitle, ModalMessage, ModalActions, ModalButton } from "./styledComponents";

function NotificationModal({ notification, onClose }) {
  if (!notification) return null;

  return (
    <ModalOverlay>
      <ModalCard>
        <ModalTitle>{notification.title}</ModalTitle>
        <ModalMessage>{notification.message}</ModalMessage>
        <ModalActions>
          <ModalButton onClick={onClose}>OK</ModalButton>
        </ModalActions>
      </ModalCard>
    </ModalOverlay>
  );
}

export default NotificationModal;

